import React from 'react';
import { useSetupProgress } from '../../hooks/useSetupProgress';

/**
 * Sits in the hub header while setup is unfinished, so from any module the
 * merchant can see how far along they are and get back to the path in one
 * click. Disappears once everything is done.
 */
export function SetupProgressPill({
  onOpen
}: {
  onOpen: () => void;
}) {
  const {
    doneCount,
    total,
    complete,
    hidden
  } = useSetupProgress();
  if (complete || hidden) return null;
  const r = 7;
  const c = 2 * Math.PI * r;
  return <button onClick={onOpen} className="inline-flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-full border border-slate-200 bg-white text-[13px] font-semibold text-dark-navy hover:border-primary-indigo/40 transition-colors duration-150 ease-out" data-id="element-2323" data-mp="2t8t2og7hdstu">
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" data-id="element-2324" data-mp="323r1g3xb7zt3">
        <circle cx="9" cy="9" r={r} fill="none" stroke="#E2E8F0" strokeWidth="2.5" data-id="element-2325" data-mp="372u2lda65lvs" />
        <circle cx="9" cy="9" r={r} fill="none" stroke="#4338CA" strokeWidth="2.5" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - doneCount / total)} transform="rotate(-90 9 9)" data-id="element-2326" data-mp="3c0luw8eq7a0i" />
      </svg>
      Setup {doneCount}/{total}
    </button>;
}